<app-container>
    <div class="row no-gutters w-100 auth-layout signup-basic-page">
        <aside class="col-12 col-lg-4">
            <div class="basic-sidebar-body">
                <div>
                    <img [src]="UIDefaultTheme.brand.logoHorizontal"
                        class="sidebar-logo d-none d-lg-flex">

                    <app-spacer [bottom]="16" class="d-none d-lg-block">
                    </app-spacer>

                    <app-stepper *ngIf="!hasNewPaper" [steps]="filteredSteps"
                        [activeIndex]="activeStep">
                    </app-stepper>
                </div>
            </div>

            <div class="basic-sidebar-footer">
                <div class="basic-sidebar-footer-content">
                    <div class="row no-gutters w-100">
                        <div class="col-4 left-side">
                            <svg-icon src="assets/images/icon-info.svg"
                                placement="top" ngbTooltip="Ajuda"
                                tooltipClass="custom-tooltip"
                                *ngIf="UIDefaultTheme.brand.supportEmail"
                                (click)="toggleSupportModal()"></svg-icon>

                            <span class="basic-sidebar-footer-text"
                                [class.text-right]="UIDefaultTheme.brand.supportEmail">
                                {{message}}
                            </span>

                            <!-- <ng-container *ngIf="loadingService.loading">
                                <div style="height: 40px; width: 200px;"></div>
                            </ng-container> -->
                        </div>

                        <div class="col-8 right-side"
                            [class.inviteLabels]="label !== null && name !== '' && activeStep >= 1">

                            <ng-container *ngIf="loadingService.loading">
                                <div style="height: 40px; width: 200px;"></div>
                            </ng-container>

                            <ng-container
                                *ngIf="label !== null && name !== '' && activeStep >= 1">
                                <div class="basic-info">
                                    <h3>{{label}}</h3>
                                    <h4>{{name}}</h4>
                                </div>
                            </ng-container>

                            <div class="button-container"
                                *ngIf="!hasNewPaper || hasNoAccess">
                                <app-button *ngIf="canGoBack()"
                                    (onClick)="goBack()" class="mr-3"
                                    [inverted]="true" [fitContent]="true">
                                    Retornar
                                </app-button>

                                <app-button
                                    [disabled]="!canProceed() || loadingService.loading"
                                    [loading]="false" (onClick)="proceed()"
                                    [next]="true" [class.d-none]="hided">
                                    <div class="basic-siderbar-footer-button">
                                        <span
                                            class="basic-sidebar-footer-button-text"
                                            [class.avaliable]="canProceed() || loading">Seguir</span>

                                        <ng-container *ngIf="canProceed()">
                                            <svg-icon
                                                [src]="'assets/images/icon_button_arrow.svg'"
                                                [class.avaliable]="canProceed() || loading">
                                            </svg-icon>
                                        </ng-container>

                                        <ng-container *ngIf="!canProceed()">
                                            <svg-icon
                                                [src]="'assets/images/icon_button_block.svg'"
                                                [class.avaliable]="canProceed() || loading">
                                            </svg-icon>
                                        </ng-container>

                                    </div>
                                </app-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </aside>

        <main class="col-12 col-lg-8 basic-content"
            [class.loading-content]="loadingService.loading">
            <!-- Badge de status do invite - aparece sempre que o invite for inválido, mesmo com modal aberto -->
            <div *ngIf="haveInvite && (!isInviteValid || inviteUsed || inviteCanceled || inviteExpired)"
                class="row no-gutters">
                <div class="offset-1 col-8">
                    <div class="invite-status-container"
                        [ngClass]="getInviteStatusContainerClass()">
                        <h3 class="invite-status-title">
                            <svg-icon [src]="getInviteStatusIcon()"></svg-icon>
                            Convite {{ getInviteStatusTitle() }}
                        </h3>
                        <p class="invite-status-message">{{
                            getInviteStatusMessage() }}</p>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="inviteChecked">
                <!-- Debug info -->
                <div *ngIf="hasNewPaper" style="display: none;">
                    {{ logDebugInfo() }}
                </div>
                <!-- Mostrar fluxo normal -->
                <ng-container [ngSwitch]="activeStep">
                    <ng-container *ngSwitchCase="0">
                        <app-signup-unified-personal [userRole]="role"
                            [disabled]="!isInviteValid"
                            [inviteStatus]="inviteStatus"
                            [inviteUsed]="inviteUsed"
                            [inviteCanceled]="inviteCanceled"
                            [inviteExpired]="inviteExpired">
                        </app-signup-unified-personal>
                    </ng-container>

                    <ng-container *ngSwitchCase="1">
                        <app-signup-unified-password>
                        </app-signup-unified-password>
                    </ng-container>

                    <ng-container *ngSwitchCase="2">
                        <app-signup-unified-profile>
                        </app-signup-unified-profile>
                    </ng-container>

                    <ng-container *ngSwitchCase="3">
                        <app-signup-unified-requirements [userRole]="role">
                        </app-signup-unified-requirements>
                    </ng-container>
                </ng-container>
            </ng-container>
        </main>
    </div>

    <ng-container *ngIf="validateForm">
        <app-basic-modal>
            <app-validate (onDigitsValidated)="onValidate($event)"
                title="Validação de segurança"
                description="Informe o código de segurança que enviamos para o número do seu celular">
            </app-validate>
        </app-basic-modal>
    </ng-container>

    <!-- Loading spinner único - exibido quando houver loading ou convite não verificado -->
    <app-loading-spinner *ngIf="loadingService.loading || !inviteChecked"
        [active]="true"></app-loading-spinner>
</app-container>
```
<ng-container *ngIf="UIDefaultTheme.brand.supportEmail">
    <app-warning-modal [active]="showSupportModal" [hasBorder]="true"
        (onClose)="toggleSupportModal()">
        <h2>Precisa de ajuda</h2>
        <app-spacer [bottom]="8"></app-spacer>
        <p>você pode entrar em contato conosco pelos meios abaixo:</p>
        <app-spacer [bottom]="8"></app-spacer>
        <a
            [href]="'mailto:' + UIDefaultTheme.brand.supportEmail">{{UIDefaultTheme.brand.supportEmail}}</a>
    </app-warning-modal>
</ng-container>

<!-- Carbon Warning Modal para vincular convite -->
<app-carbon-warning-modal [active]="showLinkInviteModal"
    [title]="getLinkInviteModalTitle()" [message]="getLinkInviteModalMessage()"
    [confirmText]="getLinkInviteConfirmText()"
    [cancelText]="getLinkInviteCancelText()" [middleText]="''"
    [disableClose]="true" [confirmAction]="logoutWithoutRedirect.bind(this)"
    [cancelAction]="cancelLinkInvite.bind(this)"
    (onClose)="closeLinkInviteModal()">
</app-carbon-warning-modal>

<!-- Carbon Warning Modal para token inválido -->
<app-carbon-warning-modal [active]="showInvalidTokenModal"
    [title]="getInvalidTokenModalTitle()"
    [message]="getInvalidTokenModalMessage()"
    [confirmText]="getInvalidTokenConfirmText()" [cancelText]="''"
    [confirmAction]="closeInvalidTokenModal.bind(this)"
    [cancelAction]="closeInvalidTokenModal.bind(this)"
    (onClose)="closeInvalidTokenModal()">
</app-carbon-warning-modal>